import { ApiSite } from "../../Constants/ConstantsValue";
import MessageUI from "../../Resources/MessageUI.json";

export const RootAction = {
    MainPage: {
        GetCompanies: "MAIN_PAGE_GET_COMPANY",
        GetOperableFiscalPeriods: "MAIN_PAGE_GET_OPERABLE_FISCAL_PERIODS",
        SetSelectedFiscalPeriodInfo: "MAIN_PAGE_SET_SELECTED_FISCAL_PERIOD_INFO",
        TransferValuesAsync: "TRANSFER_VALUES_ASYNC",
        TransferStructuresAsync: "TRANSFER_STRUCTURES_ASYNC",
        CheckAsyncStatus: "CHECK_ASYNC_STATUS",
        TransferValuesResult: "TRANSFER_VALUES_RESULT",
        TransferStructuresResult: "TRANSFER_STRUCTURES_RESULT",
        ExportCSV: "EXPORT_CSV",
    },
    ClientRequest: {
        BeforeRequest: "BEFORE_REQUEST",
        AfterRequest: "AFTER_REQUEST"
    },
    ActionState: {
        SetDisableById: "SET_DISABLE_BY_ID",
        SetActiveById: "SET_ACTIVE_BY_ID",
        SetDisableAll: "SET_DISABLE_ALL",
        SetActiveAll: "SET_ACTIVE_ALL"
    },
    Access: {
        Login: "ACCESS_LOGIN",
        ValidateAccessKey: "VALIDATE_ACCESSKEY",
        LoginFA: "ACCESS_LOGIN_FA",
        Logout: "ACCESS_LOGOUT"
    }
}

export class BaseAction {
    constructor(obj) {
        this.type = obj.type;
        this.header = obj.header ?? {
            method: obj.method,
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache'
            },
            credentials: 'include',
            body: obj.params ? JSON.stringify(obj.params) : null
        };
        this.contentType = obj.contentType ?? ContentType.Json;
        this.method = obj.method;
        this.params = obj.params;
        this.endPoint = obj.endPoint != null ? (obj.endPoint.startsWith("http") ? obj.endPoint : ApiSite + obj.endPoint) : null;
        this.isLoading = typeof obj.isLoading === 'boolean' ? obj.isLoading : true;
        //this.autoRedirect = typeof obj.autoRedirect === 'boolean' ? obj.autoRedirect : true;
        this.data = obj.data;
        this.statusCode = obj.statusCode;
    }

    SetResponse(statusCode, res) {
        this.statusCode = statusCode;
        this.data = res;
    }

    CanSetResponse(statusCode) {
        return statusCode === 200 || statusCode === 202 || statusCode === 302 || statusCode === 400;
    }

    GetComponentCaller() {
        for (let prop in RootAction) {
            if (typeof RootAction[prop] === 'object') {
                let object = RootAction[prop];
                for (const key in object) {
                    if (Object.hasOwnProperty.call(object, key)) {
                        if (object[key] === this.type) {
                            return prop;
                        }
                    }
                }
            }
        }
    }

    SetDataNotConnection() {
        this.data = {
            DetailMessage: MessageUI.LoginNotConnection
        };
    }

    HasRedirect() {
        return this.statusCode === 302;
    }

    ToPlanObject() {
        let action = JSON.parse(JSON.stringify(this));
        action.data = this.data;
        action.statusCode = this.statusCode;
        return action;
    }
}

export const ContentType = {
    Json: "json",
    Blob: "blob"
}